import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import ContextDevTool from 'react-context-devtool';
import taxDetailsReducer, { initialState } from '../reducers/taxDetailsReducer';

export const TaxDetailsContext = createContext();

const TaxDetailsProvider = ({ children }) => {
  const useTaxDetailsState = useReducer(taxDetailsReducer, initialState);

  return (
    <TaxDetailsContext.Provider value={[...useTaxDetailsState]}>
      <ContextDevTool
        context={TaxDetailsContext}
        id="TaxDetailsContext"
        displayName="TaxDetails Context"
      />
      {children}
    </TaxDetailsContext.Provider>
  );
};

TaxDetailsProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default TaxDetailsProvider;
